import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { MarginModel } from "./Margin.model";
import { ComboBoxComponent } from "../../../combo-box/combo-box.component";
import { FormComponent } from "../../../form/form.component";
import { ServiceStock } from "../../../service-stock.service";

const customCss: string = "";

@Component({
  selector: "app-Margin",
  templateUrl: "./Margin.component.html",
})
export class MarginComponent
  extends FormComponent
  implements OnInit, AfterViewInit
{
  @Output() marginSelected: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("cmbMargin", { static: false }) cmbMargin: ComboBoxComponent;
  @Input("displayLabel") displayLabel: boolean = true;
  skeletonContentLoaded = false;
  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([this.revalidateBasicField("cmbMargin")]).then(
      (errorCounts) => {
        errorCounts.forEach((errorCount) => {
          totalErrors += errorCount;
        });
      }
    );
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  constructor(services: ServiceStock) {
    super(services);
    this.value = new MarginModel();
    this.componentCode = "Margin";
    this.displayBorder = false;
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
  }
  async onFormLoad() {
    this.setInputs(
      this.services.dataStore.getData(this.services.routing.currModal)
    );
    //this.cmbMargin.setValue(this.services.dataStore.getData("marginID"));
    this.cmbMargin.setValue(this.services.dataStore.getData("setmarginGroupList"));
    this.cmbMargin.setReadOnly(false);
    this.setDependencies();
    if (this.cmbMargin.dropDownOptions.Options[1] != null) {
      this.cmbMargin.setValue(this.cmbMargin.dropDownOptions.Options[1].id);
    }
  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params["mode"]) {
      this.mode = params["mode"];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData["formName"] = "Margin";
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach((field) => {
      this.additionalInfo[field.fieldID + "_desc"] = field.getFieldInfo();
    });
    this.comboFields.forEach((field) => {
      this.additionalInfo[field.fieldID + "_desc"] = field.getFieldInfo();
    });
    // this.fileUploadFields.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
    return this.additionalInfo;
  }
  getFieldValue() {
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.value = new MarginModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  ngOnInit() {
    if (this.formCode == undefined) {
      this.formCode = "Margin";
    }
    if (this.formOnLoadError) {
      return;
    }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.innerHTML = customCss;
    styleElement.id = "Margin_customCss";
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById("Margin_customCss");
    styleElement.parentNode.removeChild(styleElement);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.subsBFldsValueUpdates();
      this.onFormLoad();
      this.checkForHTabOverFlow();
    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new MarginModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  async cmbMargin_change() {
    this.marginSelected.emit({});
  }
 /* updateMarginList(exch: string) {
    this.cmbMargin.dropDownOptions.Options =
      this.services.dataStore.getMarginByExch(
        exch,
        this.cmbMargin.dropDownOptions,
        this.cmbMargin.placeholder
      );
    if (this.cmbMargin.dropDownOptions.Options[1] != null) {
      this.cmbMargin.setValue(this.cmbMargin.dropDownOptions.Options[1].id);
    }
  }*/
  fieldDependencies = {};
}
